"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const constants_1 = require("../../../../constants");
const Home_1 = __importDefault(require("../../../../networking/apis/Home"));
const helpler_1 = require("../../../../utils/helpler");
const scale_1 = require("../../../../utils/scale");
const UserFollow_1 = __importDefault(require("./UserFollow"));
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const skeletons_1 = require("../../../../components/skeletons");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const ProfileFollowScreen = (props) => {
    const { hashtag } = props?.route?.params || props;
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [reloadPage, setReloadPage] = (0, react_1.useState)(false);
    const [dataCallApi, setDataCallApi] = (0, react_1.useState)([]);
    const [listData, setListData] = (0, react_1.useState)([]);
    const refCurrentPage = (0, react_1.useRef)(1);
    const refIsNoMore = (0, react_1.useRef)(false);
    const isFocused = (0, native_1.useIsFocused)();
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => {
        new react_native_1.NativeEventEmitter().emit(constants_1.listenerEvents.TOTAL_HASHTAG_DETAIL, dataCallApi?.uses || 0);
    }, [dataCallApi]));
    // useFocusEffect(
    // 	React.useCallback(() => {
    // 		reloadScreen()
    // 	}, []),
    // )
    (0, react_1.useEffect)(() => {
        if (isFocused) {
            reloadScreen();
        }
    }, [isFocused]);
    (0, react_1.useEffect)(() => {
        if (listData.length > 0) {
            callApiHashTagFollowUser(1, true);
        }
    }, [hashtag]);
    const callApiHashTagFollowUser = async (page, isReload) => {
        if (refIsNoMore.current)
            return;
        await Home_1.default.HashTagFollowUser({ page, hashtag })
            .then((response) => {
            refCurrentPage.current = refCurrentPage.current + 1;
            if (refCurrentPage.current > response.users.last_page) {
                refIsNoMore.current = true;
            }
            isReload && setDataCallApi(response);
            if (isReload) {
                setListData(response.users?.data);
            }
            else {
                setListData([...listData, ...response.users?.data]);
            }
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        })
            .catch((err) => {
            console.log(err);
            setReloadPage(false);
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        })
            .finally(() => { });
    };
    const reloadScreen = () => {
        refCurrentPage.current = 1;
        refIsNoMore.current = false;
        setReloadPage(true);
        callApiHashTagFollowUser(1, true);
    };
    const handleLoadMore = () => {
        callApiHashTagFollowUser(refCurrentPage.current, false);
    };
    return (react_1.default.createElement(react_native_1.View, { style: { flex: 1, backgroundColor: '#F7F7F7' } }, loading ? (react_1.default.createElement(skeletons_1.ArticleSkeleton, null)) : (react_1.default.createElement(react_native_1.FlatList, { contentContainerStyle: {
            marginTop: (0, scale_1.scale)(5),
            paddingBottom: inset.bottom + (0, scale_1.scale)(130),
        }, showsVerticalScrollIndicator: false, data: listData, renderItem: (item) => (react_1.default.createElement(react_native_1.View, { style: {
                borderBottomColor: '#DDDDDD',
                borderBottomWidth: 1,
                width: '100%',
            } },
            react_1.default.createElement(UserFollow_1.default, { data: item?.item }))), keyExtractor: (_item, index) => `${index}`, refreshing: reloadPage, onRefresh: reloadScreen, onScroll: ({ nativeEvent }) => {
            if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                handleLoadMore();
            }
        }, scrollEventThrottle: 400, ListEmptyComponent: react_1.default.createElement(react_native_1.View, { style: {
                marginTop: (0, scale_1.scale)(32),
                width: '100%',
                justifyContent: 'center',
            } },
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    fontSize: (0, scale_1.moderateScale)(16),
                    lineHeight: (0, scale_1.moderateScale)(24),
                    textAlign: 'center',
                    color: '#292A33',
                } }, `このハッシュタグは\nプロフィール・フォローでは使用されていません`)) }))));
};
exports.default = ProfileFollowScreen;
